module.exports = __webpack_public_path__ + "static/img_reward_t-shirt@2x-802864824b7029ded99e0f9f5a98c8a7.png";